var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.url),expression:"url"}],staticStyle:{"border-radius":"5px"},attrs:{"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }